import Targetings from './components/Targetings';

export default Targetings;
